import HeroCarousel from '@/components/HeroCarousel/HeroCarousel';
import PhoneAndSelectedDevice from '../LandingPageContent/PhoneAndSelectedDevice';
import { Variant } from 'services/generated/commerce-service/models/Variant';

interface Props {
  deviceImage: string;
  hoveredVariant: Variant | undefined;
  isJfHeroCarouselEnabled: boolean;
  region: string;
  selectedVariant: Variant;
  setSrc?: React.Dispatch<React.SetStateAction<string>>;
  src: string;
  language: string;
  wywImages?: string[] | undefined;
}

const HeroImages: React.FC<Props> = ({
  deviceImage,
  hoveredVariant,
  isJfHeroCarouselEnabled,
  language,
  region,
  selectedVariant,
  setSrc,
  src,
  wywImages,
}) => {
  return (
    <HeroCarousel
      hoveredVariant={hoveredVariant ?? selectedVariant}
      isJfHeroCarouselEnabled={isJfHeroCarouselEnabled}
      isMobile
      language={language}
      region={region}
    >
      <div className='relative aspect-square h-full w-full md:max-w-[700px]'>
        <PhoneAndSelectedDevice
          deviceImage={deviceImage}
          isJfHeroCarouselEnabled={isJfHeroCarouselEnabled}
          setSrc={setSrc}
          src={src}
          wywImages={wywImages}
        />
      </div>
    </HeroCarousel>
  );
};

export default HeroImages;
